import { render, staticRenderFns } from "./CarrierPage.vue?vue&type=template&id=b2fc87f6&scoped=true"
import script from "./CarrierPage.vue?vue&type=script&lang=js"
export * from "./CarrierPage.vue?vue&type=script&lang=js"
import style0 from "./CarrierPage.vue?vue&type=style&index=0&id=b2fc87f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fc87f6",
  null
  
)

export default component.exports